<template>
<crud-layout :title="title" :subtitle="subtitle">

        <template v-slot:list>
            <daily-box-list 
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"
            
            />
        </template>
        
         <add-button v-if="$store.getters.hasPermission('DAILYBOX_CREATE')" @click="create"></add-button>
      
        <daily-box-create v-if="creating" 
                        :open="creating"
                        v-on:itemCreated="onItemCreated" 
                        v-on:close="creating=false" 
        />
        
        <daily-box-update v-if="updating" 
                        :open="updating"
                        :item="itemToEdit" 
                        v-on:itemUpdated="onItemUpdated" 
                        v-on:close="updating=false" 
        />
          
        <daily-box-show v-if="showing" 
                           :open="showing" 
                           :item="itemToShow"  
                           v-on:close="showing=false" 
         />

        <daily-box-delete v-if="deleting" 
                         :open="deleting"
                         :item="itemToDelete"  
                         v-on:itemDeleted="onItemDeleted" 
                         v-on:close="deleting=false" 
        />

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>
    
    import DailyBoxCreate from "./DailyBoxCreate";
    import DailyBoxUpdate from "./DailyBoxUpdate";
    import DailyBoxDelete from "./DailyBoxDelete";
    import DailyBoxShow from "./DailyBoxShow";
    import DailyBoxList from "./DailyBoxList";
    
     import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"
     
    export default {
        name: "DailyBoxCrudPage",
        components: {
            CrudLayout, AddButton, Snackbar,
            DailyBoxCreate, 
            DailyBoxUpdate, 
            DailyBoxDelete, 
            DailyBoxShow,
            DailyBoxList
        },
        data() {
            return {
                title: 'delivery.dailyBox.title',
                subtitle: 'delivery.dailyBox.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }
        
    }
</script>


